import React from "react";
import * as styles from "./textarea.module.scss";

interface Props {
  input: any;
  meta: any;
  name: string;
  label: string;
  placeholder?: string;
  helperText?: string;
  required?: boolean;
  readOnly: boolean;
  dataType?: string;
}

export const Textarea = ({
  input,
  meta,
  label,
  placeholder,
  helperText,
  required,
  readOnly,
  dataType,
}: Props) => {
  return (
    <div className={styles.wrapper}>
      <label>{label}</label>
      <textarea
        name={label}
        value={input.value}
        onChange={input.onChange}
        required={required}
        rows={10}
        placeholder={placeholder}
        className={styles.textarea}
        data-type={dataType}
      />
    </div>
  );
};
